"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTime = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const DateTimeUtils_1 = require("chaire-lib-common/lib/utils/DateTimeUtils");
const react_i18next_1 = require("react-i18next");
const midnight = 24 * 60 * 60;
const noon = 12 * 60 * 60;
const onehour = 60 * 60;
class InputTime extends react_1.default.Component {
    constructor(props) {
        super(props);
    }
    prepareTimes() {
        const widgetConfig = this.props.widgetConfig;
        const suffixTimes = surveyHelper.parse(widgetConfig.suffixTimes, this.props.interview, this.props.path, this.props.user) || {}; // should return an object of type: [secondSinceMidnight (string)]: suffix (string)
        const secondStep = (surveyHelper.parseInteger(widgetConfig.minuteStep, this.props.interview, this.props.path, this.props.user) || 5) * 60;
        const minTime = surveyHelper.parseInteger(widgetConfig.minTimeSecondsSinceMidnight, this.props.interview, this.props.path, this.props.user);
        const maxTime = surveyHelper.parseInteger(widgetConfig.maxTimeSecondsSinceMidnight, this.props.interview, this.props.path, this.props.user);
        let minTimeSecondsSinceMidnight = minTime !== undefined ? minTime : 0;
        const maxTimeSecondsSinceMidnight = maxTime !== undefined ? maxTime : 23 * 3600 + 59 * 60 + 59;
        if (minTimeSecondsSinceMidnight % secondStep !== 0) {
            minTimeSecondsSinceMidnight += secondStep - (minTimeSecondsSinceMidnight % secondStep);
        }
        const timeOptions = [];
        for (let secondsSinceMidnight = minTimeSecondsSinceMidnight; secondsSinceMidnight <= maxTimeSecondsSinceMidnight; secondsSinceMidnight += secondStep) {
            const isTheNextDay = secondsSinceMidnight >= midnight; // midnight
            const suffix = suffixTimes[secondsSinceMidnight.toString()] || undefined;
            const has24hours = (0, LodashExtensions_1._isBlank)(this.props.t('main:pm'));
            const timeStr = (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(secondsSinceMidnight, has24hours);
            const nextDayTimeStr = isTheNextDay
                ? (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(secondsSinceMidnight - midnight, has24hours)
                : timeStr;
            if (widgetConfig.addHourSeparators &&
                secondsSinceMidnight % onehour === 0 &&
                secondsSinceMidnight !== minTimeSecondsSinceMidnight &&
                secondsSinceMidnight !== maxTimeSecondsSinceMidnight) {
                timeOptions.push(react_1.default.createElement("option", { key: `input-select-container__${secondsSinceMidnight}_disabled`, value: `disabled_${secondsSinceMidnight}`, disabled: true }));
            }
            timeOptions.push(react_1.default.createElement("option", { key: `input-select-container__${secondsSinceMidnight}`, value: secondsSinceMidnight },
                isTheNextDay
                    ? `${this.props.t('main:theNextDay')} ${nextDayTimeStr}`
                    : secondsSinceMidnight < noon
                        ? `${timeStr} ${this.props.t('main:am')}`
                        : `${timeStr} ${this.props.t('main:pm')}`,
                suffix ? suffix : ''));
        }
        return timeOptions;
    }
    render() {
        const selectOptions = this.prepareTimes();
        return (react_1.default.createElement("div", { className: "survey-question__input-select-container survey-question__input-time-container" },
            react_1.default.createElement("select", { id: this.props.id, onChange: this.props.onValueChange, value: (0, LodashExtensions_1._isBlank)(this.props.value) ? '' : this.props.value },
                react_1.default.createElement("option", { key: 'input-select-container__blank', value: "", className: 'input-select-option' }),
                selectOptions)));
    }
}
exports.InputTime = InputTime;
exports.default = (0, react_i18next_1.withTranslation)()(InputTime);
//# sourceMappingURL=InputTime.js.map